/**
 *
 * Asynchronously loads the component for Modals
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./Injectable'));
